export default "__VITE_ASSET__B3ok$Bx8__"